import { PropsWithChildren, createContext, useContext } from 'react'

/**
 * FAQセッション情報のインターフェース
 */
export interface FaqSession {
  /** セッション値を取得 */
  getValue(): string
}

const FaqSessionContext = createContext<FaqSession | null>(null)

/**
 * FAQセッション情報を取得するフック
 */
export function useFaqSession(): FaqSession {
  const session = useContext(FaqSessionContext)
  if (!session) {
    // セッションが提供されていない場合は空のセッションを返す
    return { getValue: () => '' }
  }
  return session
}

/**
 * FAQセッションプロバイダー
 */
export function FaqSessionProvider({
  children,
  session,
}: PropsWithChildren<{ session: FaqSession }>) {
  return <FaqSessionContext.Provider value={session}>{children}</FaqSessionContext.Provider>
}
